export default __webpack_public_path__ + "static/media/eye.11199f25.svg";